import { render, staticRenderFns } from "./index-task-management.vue?vue&type=template&id=e0159be2&"
import script from "./index-task-management.vue?vue&type=script&lang=js&"
export * from "./index-task-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports